import { render, staticRenderFns } from "./PatientTreatmentTimeline.vue?vue&type=template&id=57adae35&scoped=true&"
import script from "./PatientTreatmentTimeline.vue?vue&type=script&lang=ts&"
export * from "./PatientTreatmentTimeline.vue?vue&type=script&lang=ts&"
import style0 from "./PatientTreatmentTimeline.vue?vue&type=style&index=0&id=57adae35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57adae35",
  null
  
)

export default component.exports